// import Vue from 'vue'

export default class NotificationUtil {
    error(errorData) {
        alert(this.parseErrorData(errorData))
        // Vue.notify({
        //     title: 'Error',
        //     text: this.parseErrorData(errorData),
        //     type: 'error'
        // })
    }

    success(message) {
        alert(message)
        // Vue.notify({
        //     title: 'Success',
        //     text: message,
        //     type: 'success'
        // })
    }

    parseErrorData(errorData) {
        const errorTypes = Object.keys(errorData)

        for( let i = 0; i < errorTypes.length; i++ ) {
            let errorType = errorTypes[i]
            let errorMessages = errorData[errorType]
            let userErrorMessage = errorType + ' ' + errorMessages[0]
            console.log('userErrorMessage: ' + userErrorMessage)
            return userErrorMessage
        }

        return errorData
    }
}